import React from 'react';
import { useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';

import enMessages from './messages/en';

const allMessages = {
  en: enMessages,
};

export default function I18nProvider({ children }) {
  const locale = useSelector(({ i18n }) => i18n.lang);
  const messages = allMessages['en'];

  return (
    <IntlProvider locale='en' messages={messages}>
      {children}
    </IntlProvider>
  );
}
